import { render, staticRenderFns } from "./Covenants.vue?vue&type=template&id=7baf9f16&"
import script from "./Covenants.vue?vue&type=script&lang=js&"
export * from "./Covenants.vue?vue&type=script&lang=js&"
import style0 from "./Covenants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports